import { provideChameleonDesignSystem } from '@getgo/chameleon-toolkit';
import { chameleonSvg } from '../Svg/Svg.definition';
import { chameleonIconButton } from './IconButton.definition';
import { chameleonBadgeCounter } from '../BadgeCounter/BadgeCounter.definition';
provideChameleonDesignSystem().register(chameleonIconButton(), chameleonSvg(), chameleonBadgeCounter());
